import React, { useState, useEffect } from "react";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import DynamicForm from "./DynamicForm";
import LoaderComponent from "../../../libraries/loader/loader";
import { Fetchexecutequery, Fetchheaderdata, Fetchupdatequery } from "../../../services/process/BRS1/brsService7";
import { CreateData } from "../../../services/process/process_data/process_data";
import { Icon } from "semantic-ui-react";
import { IonIcon } from "@ionic/react";
import * as allIcons from "ionicons/icons";

function DepartmentCreation() {
  const [formData, setFormData] = useState({});
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [filterconditions, setFilterconditions] = useState([
    {
      is_active: 1,
      entity_id: userCredentials.entities_id,
      tenant_id: userCredentials.tenants_id,
      group_id: userCredentials.groups_id,
    },
  ]);
  const [fields, setFields] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [firstValue, setFirstValue] = useState("");
  const [secondValue, setSecondValue] = useState("");
  const [sourceOptions, setSourceOptions] = useState([]);
  const [selectedIcon, setSelectedIcon] = useState(null);
  const [search, setSearch] = useState("");
const [rows, setRows] = useState([
    {
      sheetName: "",
      startRow: 1,
      query: "",
      verificationStatus: "No",
      sourceId: "",
    },
  ]);
  const getFormattedDate = () => {
    const currentDate = new Date();
    return currentDate.toISOString().slice(0, 19).replace("T", " ");
  };

  useEffect(() => {
    fetchFieldInfo1();
    fetchFieldInfo2();
    fetchOptionsInfo(`SELECT * FROM process_data.source_master WHERE is_active=1;`,'source_name','source_id',setSourceOptions);
  }, []);


const fetchOptionsInfo = async (query1,label1,value1,setinfo) => {
  const payload = { query: query1 };

  try {
    const FileUploadCredentials = Fetchexecutequery();
    const response = await axios.post(
      FileUploadCredentials[1],
      payload,
      FileUploadCredentials[0]
    );

    const data = response.data;
    const formattedData = data.map(item => ({
      label: item[label1],
      value: item[value1]
    }));

    setinfo(formattedData);
    console.log("Formatted data fetched:", formattedData);
    
  } catch (error) {
    console.error("Error fetching page data:", error);
    setError("Error fetching page data");
  }
};


  const formatColumnName = (name) =>
    name.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

const handleChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        sheetName: "",
        startRow: 1,
        query: "",
        verificationStatus: "No",
        sourceId: "",
      },
    ]);
  };

  const handleDeleteRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };

  const fetchFieldInfo1 = async () => {
    const payload = { headerconfig_id: 75, filterconditions };

    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data.fields && data.fields.length > 0) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
          filter: true,
          sortable: true,
          resizable: true,
        }));

        columns.push({
          headerName: "Edit",
          field: "edit",
          cellRendererFramework: (params) => (
            <Icon
              name="edit"
              style={{ cursor: "pointer" }}
              onClick={() => handleEditClick(params.data)}
            />
          ),
          width: 100,
        });

        setColumnDefs(columns);
        setFields(data.fields);
      }
    } catch (error) {
      console.error("Error fetching field info:", error);
      setError("Error fetching fields data");
    }
    setLoading(false);
  };

  const fetchFieldInfo2 = async () => {
    const payload = { query: `SELECT * FROM process_data.report_config WHERE is_active=1;` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data && data.length > 0) {
        setRowData(data);
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
    }
  };

  const handleEditClick = (row) => {
    console.log("edit row ",row);
    setFormData(row);
     let configObj = row.config;

  if (typeof row.config === "string") {
    try {
      configObj = JSON.parse(row.config);
    } catch (e) {
      console.error("Failed to parse config:", e);
      configObj = {};
    }
  }

  if (configObj) {
    console.log("Parsed config", configObj);
    setFirstValue(configObj.name || "");
    setSecondValue(configObj.sideMenu || "");
    setSelectedIcon(configObj.iconName || null);
  }
    setEditMode(true);
  };

  const handleCreate = () => {
    const formattedDate = getFormattedDate();
    const updatedFormData = {
      ...formData,
      configuration: rows,
      created_date: formattedDate,
      modified_date: formattedDate,
      is_active: 1,
      created_by_user_id: userCredentials.user_id,
      modified_by_user_id: userCredentials.user_id,
    };

    const payload = {
      database: "process_data",
      table: "report_config",
      formData: updatedFormData,
    };

    const FileUploadCredentials = CreateData();

    axios
      .post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(() => {
        fetchFieldInfo2();
        resetForm();
      })
      .catch((error) => {
        console.error("Error creating data:", error);
        setError("Error creating data");
      });
  };

  const handleUpdate = () => {
    const updatedFormData = {
      ...formData,
      config_json: {
        name: firstValue,
        iconName: selectedIcon,
        sideMenu: secondValue,
      },
    };

    const payload = {
      schema_name: "user_management_uat",
      table: "pages",
      set_column: updatedFormData,
      where: [{ primary_id: formData.primary_id }],
    };

    const FileUploadCredentials = Fetchupdatequery();

    axios
      .post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(() => {
        setEditMode(false);
        fetchFieldInfo2();
        resetForm();
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });
  };

  const resetForm = () => {
    setFormData({});
    setFirstValue("");
    setSecondValue("");
    setSelectedIcon(null);
  };

  const handleInputChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (editMode) {
      handleUpdate();
    } else {
      handleCreate();
    }
  };

  if (loading) return <LoaderComponent loaderOpen={true} />;

  return (
    <div style={{ margin: "20px" }}>
      <h2 className="pt-1 pb-1 text-center" style={{ color: "#4969ab", fontSize: "18px" }}>
        REPORT CONFIG
      </h2>

      {error && <div style={{ color: "red" }}>{error}</div>}

      <DynamicForm fields={fields} formData={formData} onInputChange={handleInputChange} />
 <div style = {{padding: "10px",borderBottom: "1px solid #eee",backgroundColor: "white",borderRadius:"10px"}}>
      {rows.map((row, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "15px",
            gap: "15px",
            borderBottom: "1px solid #eee",
            padding: "10px",
          }}
        >
          {/* Sheet Name */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={{ fontSize: "12px", marginBottom: "2px" }}>
              Sheet Name
            </label>
            <input
              type="text"
              placeholder="Sheet Name"
              value={row.sheetName}
              onChange={(e) =>
                handleChange(index, "sheetName", e.target.value)
              }
              style={{ padding: "5px" }}
            />
          </div>

          {/* Start Row */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={{ fontSize: "12px", marginBottom: "2px" }}>
              Start Row
            </label>
            <select
              value={row.startRow}
              onChange={(e) => handleChange(index, "startRow", e.target.value)}
              style={{ padding: "5px" }}
            >
              {Array.from({ length: 100 }, (_, i) => i + 1).map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
          </div>

          {/* Query */}
          <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
            <label style={{ fontSize: "12px", marginBottom: "2px" }}>
              Query
            </label>
            <input
              type="text"
              placeholder="Query"
              value={row.query}
              onChange={(e) => handleChange(index, "query", e.target.value)}
              style={{ padding: "5px" }}
            />
          </div>

          {/* Verification Status */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={{ fontSize: "12px", marginBottom: "2px" }}>
              Verification
            </label>
            <select
              value={row.verificationStatus}
              onChange={(e) =>
                handleChange(index, "verificationStatus", e.target.value)
              }
              style={{ padding: "5px" }}
            >
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>

          {/* Source ID */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={{ fontSize: "12px", marginBottom: "2px" }}>
              Source ID
            </label>
            <select
              value={row.sourceId}
              onChange={(e) => handleChange(index, "sourceId", e.target.value)}
              style={{ padding: "5px" }}
            >
              <option value="">Select Source</option>
              {sourceOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
<Icon
        name="trash"
        style={{ cursor: "pointer", marginLeft: "10px", color: "red" }}
        onClick={() => handleDeleteRow(index)}
      />

      {/* Add + icon for the last row */}
      {index === rows.length - 1 && (
        <Icon
          name="plus"
          style={{ cursor: "pointer", marginLeft: "10px", color: "green" }}
          onClick={handleAddRow}
        />
      )}

        </div>
      ))}
    </div>
        <div style={{ marginTop: "10px" }}>
          <button
            onClick={handleSubmit}
            style={{
              padding: "10px 20px",
              backgroundColor: "#4969ab",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            {editMode ? "Update" : "Create"}
          </button>
        </div>


      <div className="ag-theme-alpine" style={{ height: 400, width: "100%", marginTop: "20px" }}>
        <AgGridReact rowData={rowData} columnDefs={columnDefs} pagination paginationPageSize={10} />
      </div>
    </div>
  );
}

export default DepartmentCreation;
